import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "pointRangeTemplateParent",
    "pointRanges",
    "firstRange",
    "firstRangeStart",
    "firstRangeEnd",
    "firstRangeAmount",
    "firstRangeSpacer",
    "pointRangeLabels",
    "voucherTypesSection",
  ];
  static values = {
    hasVoucherEligibleReplicationGroups: Boolean,
  };

  connect() {
    this.retailCheckbox = document.getElementById(
      "loyalty_program_earnings_rule_account_type_retail"
    );
    if (this.retailCheckbox && this.hasVoucherEligibleReplicationGroupsValue) {
      this.retailCheckbox.addEventListener("change", this.onRetailCheckboxChange);
    }
  }

  disconnect() {
    this.retailCheckbox?.removeEventListener("change", this.onRetailCheckboxChange);
  }

  onRetailCheckboxChange = (event) => {
    if (event.target.checked) {
      this.voucherTypesSectionTarget.classList.remove("hidden");
    } else {
      this.voucherTypesSectionTarget.classList.add("hidden");
    }
  };

  addPointRange() {
    // Enable the last range's end input, as the range no longer represents the final range.
    const lastRange = this.pointRangesTarget.lastElementChild;
    const lastRangeEndInput = this.#input(lastRange, "range_end");
    lastRangeEndInput.disabled = false;
    lastRangeEndInput.placeholder = "To Price";

    // Add in the new set of fields
    const newRange = this.pointRangeTemplateParentTarget.children[0].cloneNode(true);
    this.#showElement(newRange);
    this.pointRangesTarget.appendChild(newRange);

    // Convert the first points-per-dollar field to a range field as well.
    [this.firstRangeStartTarget, this.firstRangeEndTarget, this.firstRangeAmountTarget].forEach(
      (input) => {
        this.#showElement(input);
        input.classList.add("w-1/4");
      }
    );
    this.#showElement(this.firstRangeSpacerTarget);

    this.#showElement(this.pointRangeLabelsTarget);
  }

  removePointRange(event) {
    event.target.closest(".spend-rule-range").remove();

    if (this.pointRangesTarget.children.length === 1) {
      [this.firstRangeStartTarget, this.firstRangeEndTarget, this.firstRangeSpacerTarget].forEach(
        (input) => {
          input.classList.add("hidden");
        }
      );
      this.firstRangeAmountTarget.classList.remove("w-1/4");
      this.pointRangeLabelsTarget.classList.add("hidden");
    } else {
      const rangeEndInput = this.#input(this.pointRangesTarget.lastElementChild, "range_end");
      rangeEndInput.placeholder = "Infinity";
      rangeEndInput.value = "";
      rangeEndInput.disabled = true;
    }
  }

  #showElement(element) {
    element.classList.remove("hidden");
  }

  #input(scope, name) {
    return scope.querySelector(`input[name*='${name}']`);
  }
}
